export default __webpack_public_path__ + "static/media/Fox.fe5ee96e.jpeg";